import { render } from "./NewsFeatured.vue?vue&type=template&id=e2dd710c&scoped=true"
import script from "./NewsFeatured.vue?vue&type=script&lang=js"
export * from "./NewsFeatured.vue?vue&type=script&lang=js"

import "./NewsFeatured.vue?vue&type=style&index=0&id=e2dd710c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2582523138/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2dd710c"]])

export default __exports__